module.exports = __webpack_public_path__ + "img/parcel.da68e0d.jpg";